import React from "react";

import Navigation from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import "../../../static/assets/styles/style.css"
import CookiesConsentModal from "../Cookies/CookiesConsentModal";
// import styled from "@emotion/styled";

// const Wrapper = styled.div`
//   background-color: #8366F4;
//   display: flex;
//   position: relative;
//   z-index: 999;
// `

// const InnerWrapper = styled.div`
//   margin: auto;
//   display: flex;
//   padding: 0.25rem;
// `

// const Text = styled.p`
//   display: flex;
//   color: white;
//   margin: auto;
//   padding: 0 1rem;
//   font-weight: 600;
//   font-size: 16px;
//   @media screen and (max-width: 600px) {
//     font-size: 10px !important;
//   }
// `

// const ButtonLink = styled.a`
//   background-color: #8366F4;
//   color: white;
//   display: flex;
//   border: 1px solid white;
//   border-radius: 5px;
//   margin: auto;
//   height: 25px;
//   padding: 0 10px;
//   &:hover {
//     background-color: transparent;
//     box-shadow: none;
//     color: white !important;
//     opacity: 0.8;
//     text-decoration: none;
//   },
//   &:active {
//   background-color: transparent;
//   box-shadow: none;
//   color: white;
//   text-decoration: none;
// },
//   &:focus{
//   background-color: transparent;
//   box-shadow: none;
//   color: white;
//   text-decoration: none;
// },
// `

export default function Layout({ children }) {
  return (
    <>
      <Navigation />
      <CookiesConsentModal />
      <main className="pages">{children}</main>
      <Footer />
    </>
  );
}
